import React from "react";

export default function Spinner() {
  return (
    <div className="spinner_loader">
      <div className="round-spinner"></div>
    </div>
  );
}
